import React from 'react';

const EmptyState = ({ icon, title, description, actionText, onActionClick }) => {
  const isEmoji = typeof icon === 'string';

  return (
    <div className="empty-state-card">
      <div className="empty-state-icon-box">
        {isEmoji ? (
          <span className="empty-state-emoji">{icon}</span>
        ) : (
          icon && React.createElement(icon, { size: 36 })
        )}
      </div>
      <h4>{title}</h4>
      {description && <p>{description}</p>}
      {actionText && onActionClick && (
        <button onClick={onActionClick} className="btn-logout" style={{ marginTop: '12px', borderColor: '#f97316', color: '#f97316' }}>
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
